// Pruh "Akční nabídka" (eshop_item_list_akce_strip.html) se po zaškrtnutí/
// odškrtnutí facet filtru "Jen akce" i po stránkování přegeneruje jako
// AJAX fragment (#itemListContent.innerHTML se nahradí, viz
// 09_facet_autoload.js) -- staré DOM uzly i na nich zavěšené listenery
// zmizí. Proto VŠECHNO přes delegaci na document, ne addEventListener na
// konkrétní tlačítka/track při prvním načtení stránky.

function scrollStep(track) {
  const item = track.querySelector(".akceStrip__item");
  const gap = parseFloat(getComputedStyle(track).columnGap || "16");
  const itemWidth = item ? item.getBoundingClientRect().width : 220;
  return itemWidth + gap;
}

function updateNavState(track) {
  const strip = track.closest(".akceStrip");
  const prevBtn = strip && strip.querySelector(".akceStrip__nav--prev");
  const nextBtn = strip && strip.querySelector(".akceStrip__nav--next");
  if (!prevBtn || !nextBtn) return;
  const maxScroll = track.scrollWidth - track.clientWidth;
  prevBtn.disabled = track.scrollLeft <= 0;
  nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
}

document.addEventListener("click", (e) => {
  const prevBtn = e.target.closest(".akceStrip__nav--prev");
  const nextBtn = e.target.closest(".akceStrip__nav--next");
  if (prevBtn || nextBtn) {
    const strip = (prevBtn || nextBtn).closest(".akceStrip");
    const track = strip && strip.querySelector(".akceStrip__track");
    if (!track) return;
    track.scrollBy({
      left: prevBtn ? -scrollStep(track) : scrollStep(track),
      behavior: "smooth",
    });
    return;
  }

  // "Zobrazit všechny" a "(zrušit filtr "Jen akce")" jsou skutečné <a href>
  // (funkční fallback bez JS), ale normálně klik odchytíme tady: najdeme
  // stejný checkbox jako v levém sloupci (facet_custom_akce_<pk> na
  // desktopu, m_facet_custom_akce_<pk> v mobilním modálu), přepneme ho a
  // vyvoláme 'change', což 09_facet_autoload.js odchytí a pošle stejný
  // AJAX, jako kdyby na něj kliknul uživatel sám -- žádný reload.
  const showAllLink = e.target.closest(".akceStrip__showAll");
  const clearLink = e.target.closest(".sumItem__clearAkceBtn");
  const link = showAllLink || clearLink;
  if (link) {
    const pk = link.dataset.akceFacetPk;
    const checkbox =
      document.getElementById(`facet_custom_akce_${pk}`) ||
      document.getElementById(`m_facet_custom_akce_${pk}`);
    const shouldCheck = !!showAllLink;
    if (checkbox && checkbox.checked !== shouldCheck) {
      e.preventDefault();
      checkbox.checked = shouldCheck;
      checkbox.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
});

// scroll nebubluje, ale capturing fáze ano -- proto `true` jako třetí
// argument, jinak by delegace na "scroll" vůbec nic nezachytila.
document.addEventListener(
  "scroll",
  (e) => {
    const track = e.target.closest && e.target.closest(".akceStrip__track");
    if (track) updateNavState(track);
  },
  true,
);

function initAllStripsNavState() {
  document.querySelectorAll(".akceStrip__track").forEach(updateNavState);
}

initAllStripsNavState();
window.addEventListener("resize", initAllStripsNavState);

// Po AJAX výměně obsahu (#itemListContent.html(...) v 09_facet_autoload.js)
// se stav šipek pro novou instanci pruhu musí přepočítat znovu -- žádná
// vlastní bublající událost pro "obsah se vyměnil" v projektu neexistuje.
const itemListContent = document.getElementById("itemListContent");
if (itemListContent) {
  new MutationObserver(initAllStripsNavState).observe(itemListContent, {
    childList: true,
    subtree: true,
  });
}
